import ApiService from '@/services/common/api.service';
import Utils from '@/helpers/utils';
import DateUtils from '@/helpers/dateUtils';
import { Constants } from "@/helpers/constants";
import _ from 'lodash';

const DMOSManagementService = {
    listDMOS,
    addDMOS,
    detailDMOS,
    editDMOS,
    deleteDMOS,
};

/*
    List DMOS
*/
async function listDMOS (page) {
    let url = '/dmos';

    let query = {};

    if (page) {
        query.page = page;
        query.pageSize = Constants.ItemPerpage;
    }

    if (Utils.isEmptyObj(query) == false) {
        let httpBuildQuery = require('http-build-query');
        url += "?" + httpBuildQuery(query);
    }

    try {
        let response = await ApiService.get(url);
        return response;
    } catch (error) {
        return error;
    }
}

/*
    Add DMOS
*/
async function addDMOS (params) {
    let url = '/dmos';

    let body = {};

    Utils.trimObject(params);

    body.connection = _.trim(params.connection);
    body.loginId = _.trim(params.loginId);
    body.loginPw = _.trim(params.loginPw);
    body.new_accounting_flag = params.new_accounting_flag;

    if (!Utils.isEmptyStr(params.start)) {
        body.start = DateUtils.formatDateDefault(params.start);
    } else {
        body.start = "";
    }

    if (!Utils.isEmptyStr(params.end)) {
        body.end = DateUtils.formatDateDefault(params.end);
    } else {
        body.end = "";
    }

    try {
        let response = await ApiService.post(url, body);
        return response;
    } catch (error) {
        return error;
    }
}

/*
    Detail DMOS
*/
async function detailDMOS (id) {
    let url = '/dmos/' + id;
    try {
        let response = await ApiService.get(url);
        return response;
    } catch (error) {
        return error;
    }
}

/*
    Edit DMOS
*/
async function editDMOS (ids, params) {
    let url = "/dmos";

    let body = {};

    Utils.trimObject(params);

    if (ids.length == 1) {
        url = url + "/" + ids[0];
    } else {
        body.ids = ids;
    }

    body.connection = _.trim(params.connection);
    body.loginId = _.trim(params.loginId);
    body.loginPw = _.trim(params.loginPw);
    body.new_accounting_flag = params.new_accounting_flag;

    if (!Utils.isEmptyStr(params.start)) {
        body.start = DateUtils.formatDateDefault(params.start);
    } else {
        body.start = "";
    }

    if (!Utils.isEmptyStr(params.end)) {
        body.end = DateUtils.formatDateDefault(params.end);
    } else {
        body.end = "";
    }

    try {
        let response = await ApiService.put(url, body);
        return response;
    } catch (error) {
        return error;
    }
}

/*
    Delete DMOS
*/
async function deleteDMOS (ids) {
    let url = '/dmos';
    let body = {};

    if (ids.length == 1) {
        url = url + "/" + ids[0];
    } else {
        body.ids = ids;
    }

    let requestData = {
        method: 'DELETE',
        url: url,
        data: body,
    };

    try {
        let response = await ApiService.customRequest(requestData);
        return response;
    } catch (error) {
        return error;
    }
}

export default DMOSManagementService;



// WEBPACK FOOTER //
// ./src/services/admin/dmos.service.js